import { render, staticRenderFns } from "./sign-in-ecnu.vue?vue&type=template&id=7cf2984f&scoped=true&"
import script from "./sign-in-ecnu.vue?vue&type=script&lang=js&"
export * from "./sign-in-ecnu.vue?vue&type=script&lang=js&"
import style0 from "./sign-in-ecnu.vue?vue&type=style&index=0&id=7cf2984f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf2984f",
  null
  
)

export default component.exports